module.exports = __webpack_public_path__ + "img/change.e0a79a4a.svg";